'use client';
import { GroqImage } from '@/helpers/Image';
import { GROQButton } from '@/sanity/lib/definitions';
import { richTextComponent } from '@/sanity/sanityPortableText';
import { CTAButton } from '@/shadcn/ui/button';
import { motion } from 'framer-motion';
import { PortableText } from 'next-sanity';
import { PortableTextBlock } from 'sanity';

interface IDesigned {
  title: PortableTextBlock[];
  description: PortableTextBlock[];
  ctaButton1: GROQButton;
  ctaButton2: GROQButton;
}

export default function DesignedSection({
  title,
  description,
  ctaButton1,
  ctaButton2,
}: IDesigned) {
  return (
    <section id="designed-section" className="flex flex-col gap-[4rem] pt-[5rem] pb-[9rem] lg:pt-[36.25rem] lg:pb-[47.5rem] container lg:max-w-[223.5rem]">      
      <svg className="w-[6.42588rem] aspect-[51.41/44]" viewBox="0 0 52 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M51.4069 13.6627L51.0902 13.3258C49.4179 13.7717 46.3899 14.376 42.6593 14.2671L42.3723 14.5544C43.0947 16.2783 44.0447 19.9144 40.5516 22.2427C37.5235 24.571 34.0008 24.3432 31.3488 21.6384C27.4797 17.6852 25.7875 11.2749 27.9942 8.93672C28.9145 7.92614 30.0525 7.39113 30.9332 7.11371V6.7174C28.3109 4.17113 26.7375 1.56541 25.9459 0H25.461C24.6595 1.56541 23.0861 4.18104 20.4737 6.7174V7.11371C21.3544 7.39113 22.4924 7.92614 23.4126 8.93672C25.6193 11.2749 23.9272 17.6852 20.0581 21.6384C17.416 24.3432 13.8932 24.5809 10.8553 22.2427C7.37211 19.9144 8.31218 16.2783 9.03454 14.5544L8.74757 14.2671C5.01699 14.376 1.98899 13.7717 0.316654 13.3258L0 13.6627C0.573936 15.2875 1.35567 18.2103 1.22703 21.8662L1.514 22.1536C4.70034 20.8755 7.00598 22.1238 8.93559 23.4118C17.6733 29.2376 23.0861 35.9847 25.4511 44H25.936C28.301 35.9847 33.7138 29.2376 42.4515 23.4118C44.3811 22.1238 46.6966 20.8755 49.8731 22.1536L50.16 21.8662C50.0314 18.2202 50.8131 15.2875 51.3871 13.6627H51.4069ZM25.7183 37.4213C23.4918 33.052 20.9685 30.1788 17.1686 26.3346C21.9778 25.1754 24.6397 20.707 25.7183 17.4078C26.7969 20.707 29.4588 25.1754 34.2679 26.3346C30.4681 30.1788 27.9447 33.0619 25.7183 37.4213Z" fill="#F2F0EF"/>
      </svg>

      <div className="flex flex-col lg:flex-row w-full gap-[6rem] lg:gap-0">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1.2, ease: [0.25, 1, 0.5, 1] }}
          className="w-full uppercase text-offwhite lg:prose-h2:leading-[120%] prose-h2:leading-[110%]"
        >
          {title && (
            <PortableText value={title} components={richTextComponent} />
          )}
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1.2, ease: [0.25, 1, 0.5, 1], delay: 0.15 }}
          className="flex flex-col gap-[2rem] lg:gap-[3rem] w-full lg:w-[89.375rem] prose-p:text-[2rem] lg:prose-p:text-[3rem] prose-p:leading-[130%] prose-p:font-[300] prose-p:text-[#F2F0EF]/70 flex-shrink-0"
        >
          {description && (
            <PortableText
              value={description}
              components={richTextComponent}
            />
          )}
        </motion.div>

        <div className="flex flex-col lg:hidden gap-[2rem]">
          {ctaButton1 && (
            <CTAButton data={ctaButton1} />
          )}
          {ctaButton2 && (
            <CTAButton data={ctaButton2} />
          )}
        </div>
      </div>
    </section>
  );
}
